import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "./Banner.css";

import "swiper/css";
import "swiper/css/effect-fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Popup_holder from "../../../components/Common-Component/Commonmodal/Popup_holder/Popup_holder";
import { luxuryBanner } from "../../../utils/luxuryapis/Home/Homeapi";
import { Context } from "../../../utils/context";

const Banner = () => {
  const { IMG_URL } = useContext(Context);

  const [swiperInstance, setSwiperInstance] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [banners, serBanners] = useState();
  const closePopup = () => {
    setShowPopup(false);
  };

  const handleMainSliderClick = (direction) => {
    if (!swiperInstance) return;

    if (direction === "prev") {
      swiperInstance.slidePrev();
    } else if (direction === "next") {
      swiperInstance.slideNext();
    }
  };

  const getAllLuxuryBanner = async () => {
    const res = await luxuryBanner();
    if (res?.success) {
      serBanners(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryBanner();
  }, []);

  console.log(banners,"banners banners");
  
  const dataBanner = [
    "/assest/luxury_images/home/img1.webp",
    // "/assest/luxury_images/home/img1.webp",
    // "/assest/luxury_images/home/img1.webp",
  ];

  return (
    <section className="home-banner luxury_home_banner">
      <div className="container-fluid ">
        <div className="row p-0">
          <div className="col-md-12 p-0">
            <Swiper
              spaceBetween={20}
              loop={true}
              slidesPerView={1}
              onSwiper={(swiper) => setSwiperInstance(swiper)}
              onSlideChange={() => console.log("slide change")}
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              // speed={500}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay, EffectFade]}
              effect="fade"
              className="mySwiper"
            >
              {banners?.map((val) => (
                <SwiperSlide>
                  <div
                    className="image-holder p-0"
                    // onClick={() => {
                    //   setShowPopup(true);
                    // }}
                  >
                    <img
                      className="ban-image"
                      src={IMG_URL + val?.image}
                      alt="Logo"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>

      <div className="silder_btn">
        <div className="back_btn_holder">
          <div
            className="back_btn"
            onClick={() => handleMainSliderClick("prev")}
          >
            <p>
              {" "}
              <FontAwesomeIcon icon={faAngleLeft} />
            </p>
          </div>
        </div>
        <div className="back_btn_holder">
          <div
            className="back_btn"
            onClick={() => handleMainSliderClick("next")}
          >
            <p>
              {" "}
              <FontAwesomeIcon icon={faAngleRight} />
            </p>
          </div>
        </div>
      </div>

      {showPopup && (
        <Popup_holder text="Launching Soon" onClose={closePopup} /> // Render the popup if visible
      )}
    </section>
  );
};

export default Banner;
